import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { InvoiceComponent } from './invoice.component';
import { InvoicePopupComponent } from './invoice-dialog.component';
import { InvoiceRequestPopupComponent } from './invoice-request-dialog.component';
import { InvoiceDeletePopupComponent } from './invoice-delete-dialog.component';
import { InvoiceFinalizePopupComponent } from './invoice-finalize-dialog.component';
import { InvoiceReversePopupComponent } from './invoice-reverse-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class InvoiceResolvePagingParams implements Resolve<any> {

    constructor(private paginationUtil: PaginationUtil) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        let sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'invoiceDate,desc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    }
}

export const InvoiceRoute: Routes = [
    {
        path: 'invoice',
        component: InvoiceComponent,
        resolve: {
            'pagingParams': InvoiceResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.invoice.home.title'
        }
    }
];

export const InvoicePopupRoute: Routes = [
    {
        path: 'invoice-new/:paymentId',
        component: InvoicePopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN'],
            pageTitle: 'jYoguiApp.invoice.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'invoice-request/:paymentId',
        component: InvoiceRequestPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.invoice.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'invoice/:id/edit',
        component: InvoicePopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN'],
            pageTitle: 'jYoguiApp.invoice.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'invoice/:id/edit-invoice-request',
        component: InvoiceRequestPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.invoice.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'invoice/:id/delete',
        component: InvoiceDeletePopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN'],
            pageTitle: 'jYoguiApp.invoice.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'invoice/:id/finalize',
        component: InvoiceFinalizePopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN'],
            pageTitle: 'jYoguiApp.invoice.action.finalize'
        },
        outlet: 'popup'
    },
    {
        path: 'invoice/:id/reverse',
        component: InvoiceReversePopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN'],
            pageTitle: 'jYoguiApp.invoice.action.reverse'
        },
        outlet: 'popup'
    }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/invoice/invoice.route.ts